'use client';

import { Gift } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { isGiftRemaining } from '@/lib/gift-action-presentation';

/** Use inside the action button, only with an authoritative free-use allowance. */
export function GiftActionLabel({ action, remaining }: { action: string; remaining: number | null }) {
  const t = useTranslations('common');
  if (!isGiftRemaining(remaining)) return <>{action}</>;
  return (
    <span className="inline-flex min-w-0 flex-wrap items-center justify-center gap-x-2 gap-y-1 leading-5 text-[#102F3D]" data-free-gift-action>
      <span>{action}</span>
      <span className="inline-flex items-center gap-1 rounded-md bg-white/35 px-1.5 py-0.5 text-[11px] font-semibold ring-1 ring-[#102F3D]/15">
        <Gift className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        {t('giftActionFreeUse', { count: 1 })}
      </span>
    </span>
  );
}
